import { render, staticRenderFns } from "./SyllabusSections.vue?vue&type=template&id=17fe91ae&scoped=true&"
import script from "./SyllabusSections.vue?vue&type=script&lang=js&"
export * from "./SyllabusSections.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusSections.vue?vue&type=style&index=0&id=17fe91ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe91ae",
  null
  
)

export default component.exports